import React from 'react'
import PropTypes from 'prop-types'
import { Dimmer, Loader } from 'semantic-ui-react'
import { css } from 'aphrodite'
import { Image } from './Image'
import createStyles from './styles'

export class Card extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)

    return (
      <div className={css(styles.root)}>
        {this.props.image && (
          <Image
            source={this.props.image}
            width={130}
            height={130}
            style={styles.image}
          />
        )}

        <div className={css(styles.main)}>
          <Dimmer
            inverted
            active={this.props.loading}
            className={css(styles.dimmer)}
          >
            <Loader size="massive" />
          </Dimmer>

          {this.props.children && !this.props.loading
            ? this.props.children
            : null}
        </div>
      </div>
    )
  }
}

Card.contextTypes = {
  theme: PropTypes.object,
}

Card.propTypes = {
  image: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  loading: PropTypes.bool,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    backgroundColor: theme.colors.foreground,
    boxShadow: '0px 5px 20px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 10,
    marginBottom: 21,
    padding: 45,
    position: 'relative',
    textAlign: 'center',
  },

  image: {
    background:
      'linear-gradient(180deg, hsla(0, 0%, 100%, .5), hsla(0, 0%, 100%, .5))',
    border: '3px solid #ffffff',
    borderRadius: '100%',
    marginTop: '-20%',
  },

  main: {
    textAlign: 'left',
  },

  dimmer: {
    borderRadius: 4,
  },
}))



// WEBPACK FOOTER //
// ./src/components/Card.js